import React from 'react';
import WorkspaceCardItem from './WorkspaceCardItem';

const WorkspaceCardItems = ({
  category,
  hasConditions,
  items,
  onCheckBoxClick,
  single,
}) => (
  items.map((item, index) => (
    <WorkspaceCardItem
      key={`workspaces_card_item_${item.uuid}`}
      category={category}
      hasConditions={hasConditions}
      workspace={item}
      onCheckBoxClick={onCheckBoxClick}
      single={single}
      upward={index > 4}
    />
  ))
);

export default WorkspaceCardItems;
